module.exports = __webpack_public_path__ + "static/iwantacookie-552b45c61e6ad9ad0e1969d4ba27cb95.png";